import "oc-interaction/events/pantouch.js";
import {v2} from "oc-threejs/short3.js";

export default class Drags {

    /**
     * Macht ein Element per Drag verschiebbar, allerdings nur im Sinne von "anders absolut positionieren"
     * und nicht im Sinne von "auf etwas fallenlassen".
     *
     * @param element das als ganzes verschiebbare Element, z.B. ein Dialog
     * @param sensorChild optional, Anfasser für Drag und Kind des Elements, z.B. Dialogtitel
     */
    static makeUiElementMoveable(element,sensorChild=null) {

        sensorChild = sensorChild || element;

        sensorChild.css('cursor', 'pointer');
        let deltaDrag = null;

        function ondragmove(event) {
            event.preventDefault();
            event.stopPropagation();
            const pos = v2(event.pageX, event.pageY).add(deltaDrag);
            element.css({
                top: pos.y + 'px',
                left: pos.x + 'px',
            });
        }

        function ondragup(event) {
            // console.log('* ondragup');
            event.preventDefault();
            sensorChild.css('cursor', 'pointer');
            $(document).off('dragmove',ondragmove);
            $(document).off('dragup',ondragup);
        }

        sensorChild.on('dragdown', (event)=> {
            event.preventDefault();
            sensorChild.css('cursor', 'move');
            const startPosition = v2(event.pageX, event.pageY);
            const position = element.position();
            deltaDrag = v2(position.left, position.top).sub(startPosition);
            $(document).on('dragmove', ondragmove);
            $(document).on('dragup', ondragup);
        });

    }

}
